import styled from 'styled-components';

export const StyledSetupWizardItemBadge = styled.div`
    display: flex;
    align-items: center;
`;
